/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Tooltip from 'flarum/common/components/Tooltip';
import { components } from '@glowingblue-orell-thalia-common';

const { HomeActivityLeaderboard } = components;
import RatingsBestArticleItem from './RatingsBestArticleItem';
import HomeRatingsLeaderboardState from '../states/HomeRatingsLeaderboardState';
import type Article from 'flarum/orell-articles/models/Article';
import type LiteraryWork from 'flarum/orell-articles/models/LiteraryWork';

export default class HomeRatingsLeaderboard extends HomeActivityLeaderboard<LiteraryWork, HomeRatingsLeaderboardState> {
	/** Whether the leaderboard currently covers the past year rather than the default range. */
	pastYear?: boolean;

	listItem(work: LiteraryWork, position: number) {
		// The endpoint backing this leaderboard always includes `mainArticle`.
		const article = work.mainArticle() as Article;
		article.data.attributes!.recentRatingAvg = work.data.attributes!.recentRatingAvg;
		return <RatingsBestArticleItem article={article} position={position} />;
	}

	get titleText() {
		return app.translator.trans('glowingblue-orell-rezensionen.forum.home.ratings_leaderboard.title');
	}

	get subTitleText() {
		return (
			<span className="HomeRatingsLeaderboard-ranges">
				<span onclick={() => this.setRange()} className={this.pastYear ? '' : 'active'}>
					{app.translator.trans('glowingblue-orell-rezensionen.forum.home.ratings_leaderboard.sub_title', { days: this.nDays })}
				</span>
				<Tooltip text={app.translator.trans('glowingblue-orell-rezensionen.forum.home.ratings_leaderboard.past_year_tooltip') as string}>
					<span onclick={() => this.setRange(true)} className={this.pastYear ? 'active' : ''}>
						{app.translator.trans('glowingblue-orell-rezensionen.forum.home.ratings_leaderboard.past_year')}
					</span>
				</Tooltip>
			</span>
		);
	}

	get emptyText() {
		return app.translator.trans('glowingblue-orell-rezensionen.forum.home.ratings_leaderboard.empty_text', { days: this.nDays });
	}

	get stateManager() {
		return HomeRatingsLeaderboardState;
	}

	setRange(pastYear: boolean | null = null) {
		this.pastYear = !!pastYear;
		m.redraw();

		// The page argument is required by the typings only; this list is one page anyway.
		this.state.refreshParams({ pastYear }, 1);
	}
}
